import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosGenericoAsync} from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { visualizarReporteEnPdf, generarReporteEnExcel } from '../../funciones_globales/interaccionApiReportes';

class FormCli20 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Global

            cliente_sel: null,
            vendedor_sel: null,

        };

        this.limpiar = this.limpiar.bind(this);
        this.imprimir = this.imprimir.bind(this);
        this.actualizarCampos = this.actualizarCampos.bind(this);
        this.generarRptExcel = this.generarRptExcel.bind(this);
        
    }

    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({[name]: value});
    }

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0120')
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0120');
    }

    imprimir(){
        try{
            let urlReportWithParams=`&rpt=164`; 


            if(this.state.cliente_sel){
                urlReportWithParams+=`&param1=${this.state.cliente_sel.value}`;
            }

            if(this.state.vendedor_sel){
                urlReportWithParams+=`&param2=${this.state.vendedor_sel.value}`;
            }

            visualizarReporteEnPdf(urlReportWithParams);
            
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    generarRptExcel(){
        try{
            let urlReportWithParams=`&rpt=165`; 


            if(this.state.cliente_sel){
                urlReportWithParams+=`&param1=${this.state.cliente_sel.value}`;
            }

            if(this.state.vendedor_sel){
                urlReportWithParams+=`&param2=${this.state.vendedor_sel.value}`;
            }

            generarReporteEnExcel(urlReportWithParams);
            
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }


    limpiar(){
        this.setState({cliente_sel: null, vendedor_sel: null})
    }

    getOptions_Clientes(input, callback){
        if (input.toString().length >= 2 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;
          cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    getOptions_Vendedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/vendedores', cadena_busq, callback)              
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
                <HeaderForm>
                    <TituloForm>Reporte de Cliente con Amenaza de Siniestro</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Cliente:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{this.setState({cliente_sel: value!==null?value:null})}}/>
                        </ContainerCol>
                    </Row>  
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Vendedor:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.vendedor_sel} func_loadOptions={this.getOptions_Vendedores} func_onChange={(value)=>{this.setState({vendedor_sel: value!==null?value:null})}}/>
                        </ContainerCol>
                    </Row>

                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimir}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type='button' className='btn btn-success btn-sm' onClick={()=>{this.generarRptExcel()}}><i className="fa fa-file-excel-o fa-lg" aria-hidden="true"/> Imprimir Detalle Excel</button>
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>

                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormCli20);